export enum UI_TRACKING_ACTION {
    NAVIGATION = 'navigation',
    CONTENT_PLAY = 'content_play',
    CONTENT_PAUSE = 'content_pause',
    CONTENT_CREATION = 'content_creation',
    CONTENT_EDIT = 'content_edit',
    CONTENT_DELETE = 'content_delete'
}

export enum TRACKING_CONTENT_TYPE{
    KEY_MOMENT = 'key_moment',
    CLIP = 'clip'
}

export enum TRACKING_OUTCOME{
    SUCCESS = 'success',
    FAILURE = 'failure',
}